import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

let TZ = "America/New_York";
export const setTz = (tz) => { TZ = tz || "America/New_York"; };
export const getTz = () => TZ;

export function fmtTime(iso, withDate = false) {
  if (!iso) return "—";
  const d = new Date(iso);
  const opt = { timeZone: TZ, hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" };
  if (withDate) Object.assign(opt, { month: "short", day: "2-digit" });
  return d.toLocaleString("en-US", opt);
}

export function fmtBytes(n) {
  if (n == null) return "—";
  const u = ["B", "KB", "MB", "GB", "TB"];
  let i = 0;
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(i ? 1 : 0)} ${u[i]}`;
}

export function fmtBps(n) {
  if (n == null) return "—";
  if (n > 1e9) return `${(n / 1e9).toFixed(2)} Gb/s`;
  if (n > 1e6) return `${(n / 1e6).toFixed(2)} Mb/s`;
  return `${(n / 1e3).toFixed(1)} kb/s`;
}

export function fmtDur(s) {
  if (s == null) return "—";
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${s % 60}s`;
  return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
}
